"use client";
import * as React from "react";
const SvgSentimentSatisfiedFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m10.8-.8a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4M6.4 6A1.2 1.2 0 1 1 4 6a1.2 1.2 0 0 1 2.4 0m.03 4.78A3 3 0 0 0 8 11.2a3 3 0 0 0 1.58-.42c.4.45.4.46.4.47l.4.45a4.4 4.4 0 0 1-4.76 0c.12-.13.72-.8.81-.92", clipRule: "evenodd" }));
export {
  SvgSentimentSatisfiedFilled as default
};
